/** This export is automatically generated */
export const gitHash = 'ecc293263';
